export default "__VITE_ASSET__WeYF2s7U__"